import * as React from 'react';
import { Select } from '@rendering/components';
import { PROFILE_COLORS } from '../../documents/slice';
import { useMemo } from 'react';

interface ColorProfileProps {
    onSelect: (e: any) => void;
    activeProfile?: string;
}

const ColorProfile = (props: ColorProfileProps) => {
    const { activeProfile, onSelect } = props;
    const value = useMemo(() => {
        // Match case-insensitively: the rendering engine parses colorProfile case-insensitively
        // (see ColorProfileHelper.cs), and older saved scenes may use different casing
        // (e.g. "UsWebCoatedSWOP") than the shared @rendering/types values.
        const profileValue = PROFILE_COLORS.find((color) => color.value.toLowerCase() === activeProfile?.toLowerCase());
        if (profileValue) {
            return profileValue;
        }
        return PROFILE_COLORS[0];
    }, [activeProfile]);
    return (
        <div className='advanced_color-profile'>
            <Select
                label='Color Profile'
                className='color-profile__select'
                options={PROFILE_COLORS}
                value={value}
                onChange={onSelect}
                isClearable={false}
                isSearchable={false}
            />
        </div>
    );
};

export default ColorProfile;
